module.exports = __webpack_public_path__ + "img/arl-logo-min.120fae22.png";